export default class Search {
	constructor(biblia) {
		this.biblia = biblia;
	}

	initialize() {
		this.setSearchBooks();
	}

	setSearchBooks() {
		const input = document.querySelector('#biblia-online #search-books');
		input.addEventListener('input', () => {
			const books = document.querySelectorAll('#biblia-online .list > div');
			books.forEach(book => {
				const name = book.querySelector('.book > span');
				if (!book.classList.contains('filtered')) {
					book.classList.remove('deactive');

					if (!name.innerText.toUpperCase().includes(input.value.toUpperCase())) {
						book.classList.add('deactive');
					}
				}
			});
		});
	}

}
